import React, { useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    fname: '',
    lname: '',
    state: 'State',
    city: '',
    role: 'Educator',
    message: '',
    success: false,
    _wpcf7_unit_tag: 'wpcf7-f' + '4958' + '-123'
  });

  const handleInputChange = event => {
    const { name, value } = event.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = event => {
    event.preventDefault();
    const formEndpoint =
      'https://backend-api.worldsavvy.org/wp-json/contact-form-7/v1/contact-forms/4982/feedback';
    const body = new FormData(document.getElementById('contactform'));
    console.log(formData);
    Object.entries(formData).forEach(([key, value]) => {
      body.append(key, value);
    });

    fetch(formEndpoint, {
      method: 'POST',
      body: body,
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        setFormData({
          email: '',
          role: 'Educator',
          fname: '',
          lname: '',
          city: '',
          state: '',
          message: '',
          submitting: false,
          success: true,
          _wpcf7_unit_tag: 'wpcf7-f' + '4958' + '-123'
        });
      });
  };

  return (
    <form id='contactform' onSubmit={handleSubmit} name='contactform'>
      <ul className='radio-check-list connect-check-list'>
        <li>
          <p className='mb-0'>
            <strong>I am a/n:</strong>
          </p>
        </li>
        <li>
          <input
            type='radio'
            value='Educator'
            id='educator2'
            checked={formData.role === 'Educator'}
            onChange={handleInputChange}
            name='role'
          />
          <label htmlFor='educator2'>Educator</label>
        </li>
        <li>
          <input
            type='radio'
            value='School Leader'
            checked={formData.role === 'School Leader'}
            onChange={handleInputChange}
            id='school_leader2'
            name='role'
          />
          <label htmlFor='school_leader2'>School Leader</label>
        </li>
        <li>
          <input
            type='radio'
            value='Donor'
            id='donor2'
            checked={formData.role === 'Donor'}
            onChange={handleInputChange}
            name='role'
          />
          <label htmlFor='donor2'>Donor</label>
        </li>
        <li>
          <input
            type='radio'
            value='Other'
            id='other2'
            checked={formData.role === 'Other'}
            onChange={handleInputChange}
            name='role'
          />
          <label htmlFor='other2'>Other</label>
        </li>
      </ul>
      <div className='form-group'>
        <input
          type='text'
          className='form-control'
          value={formData.fname}
          onChange={handleInputChange}
          placeholder='First Name'
          name='fname'
        />
      </div>
      <div className='form-group'>
        <input
          type='text'
          className='form-control'
          value={formData.lname}
          onChange={handleInputChange}
          placeholder='Last Name'
          name='lname'
        />
      </div>
      <div className='form-group'>
        <input
          type='email'
          className='form-control'
          value={formData.email}
          onChange={handleInputChange}
          placeholder='Email *'
          name='email'
          required
        />
      </div>
      <div className='form-group'>
        <input
          type='text'
          className='form-control'
          value={formData.city}
          onChange={handleInputChange}
          placeholder='City'
          name='city'
        />
      </div>
      <div className='form-group'>
        <select
          className='form-control'
          name='state'
          value={formData.state}
          onChange={handleInputChange}
        >
          <option>State </option>
          <option>Alaska </option>
          <option>Arizona </option>
          <option>Arkansas </option>
          <option>California </option>
          <option>Colorado </option>
          <option>Connecticut </option>
          <option>Delaware </option>
          <option>Florida </option>
          <option>Georgia </option>
          <option>Hawaii </option>
          <option>Idaho </option>
          <option>Illinois </option>
          <option>Indiana </option>
          <option>Iowa </option>
          <option>Kansas </option>
          <option>Kentucky </option>
          <option>Louisiana </option>
          <option>Maine </option>
          <option>Maryland </option>
          <option>Massachusetts </option>
          <option>Michigan </option>
          <option>Minnesota </option>
          <option>Mississippi </option>
          <option>Missouri </option>
          <option>Montana </option>
          <option>Nebraska </option>
          <option>Nevada </option>
          <option>New Hampshire </option>
          <option>New Jersey </option>
          <option>New Mexico </option>
          <option>New York </option>
          <option>North Carolina </option>
          <option>North Dakota </option>
          <option>Ohio </option>
          <option>Oklahoma </option>
          <option>Oregon </option>
          <option>Pennsylvania </option>
          <option>Rhode Island </option>
          <option>South Carolina </option>
          <option>South Dakota </option>
          <option>Tennessee </option>
          <option>Texas </option>
          <option>Utah </option>
          <option>Vermont </option>
          <option>Virginia </option>
          <option>Washington </option>
          <option>West Virginia </option>
          <option>Wisconsin </option>
          <option>Wyoming </option>
        </select>
      </div>
      <div className='form-group'>
        <textarea
          className='form-control'
          name='message'
          value={formData.message}
          onChange={handleInputChange}
          placeholder='Message'
        ></textarea>
      </div>
      <div className='form-group'>
        <input className='btn blue-btn' type='submit' value='Submit' />
        {formData.success && (
          <p id='hp-form' style={{ color: 'black' }}>
            Form submitted successfully!
          </p>
        )}
      </div>
    </form>
  );
};

export default ContactForm;
